/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_NavigationInputs */

const en_gc_editor_navigation = /** @type {(inputs: Gc_Editor_NavigationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor navigation`)
};

const zh_gc_editor_navigation = /** @type {(inputs: Gc_Editor_NavigationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑器导航`)
};

/**
* | output |
* | --- |
* | "Editor navigation" |
*
* @param {Gc_Editor_NavigationInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_navigation = /** @type {((inputs?: Gc_Editor_NavigationInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_NavigationInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_navigation(inputs)
	return zh_gc_editor_navigation(inputs)
});
export { gc_editor_navigation as "gc.editor.navigation" }